<template>
  <div id="commend">
    <div class="t">
      <div class="tx1 lv1Text">人气商品</div>
      <div class="tx2 lv2Text">给您最优惠的价格</div>
    </div>
    <div class="table">
      <el-row :gutter="60">
        <el-col :span="12" v-for="(item,index) of data" :key="index">
          <div class="item">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-image
                    lazy
                    style="width: 180px; height: 120px"
                    :src="serve +item.images"
                    fit="cover"
                  ></el-image>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="info">
                  <div class="lv1Text tx11">
                    {{_.truncate(item.title, {
                    'length': 24,
                    })}}
                  </div>
                  <div class="lv2Text">
                    特惠价：
                    <span class="lv0Text">&yen;{{item.selling_price}}</span>
                  </div>
                  <el-button type="primary" round size="small" class="btn" @click="go(item.id)">立即购买</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      data: {},
      page: 1
    };
  },
  watch: {},
  created() {
    //
    this.initData();
  },
  methods: {
    //
    go(id) {
      this.$router.push("/view?id=" + id);
    },
    initData() {
      var that = this;
      this.axios.get(this.serve + "/hot").then(res => {
        this.data = res.data;
      });
    }
  }
};
</script>
<style lang="scss">
#commend {
  padding: 30px 0;
  .lv2Text {
    margin-bottom: 10px;
  }
  .tx1 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .t {
    background-color: #eaedf1;
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    padding: 20px 0;
    border: 1px solid #ddd;
  }
  .tx11 {
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .table {
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    .item {
      background-color: #fff;
      margin-bottom: 20px;
    }
  }
  .info {
    .el-button {
      float: right;
      margin-right: 20px;
      width: 100px;
    }
  }
}
</style>